import Api from './api.service';

const ENDPOINT = 'push-notifications';

export default {
  send: (message) => Api.post(`${ENDPOINT}/send`, message),
};
